import axios from 'axios'
import router from './../../../router'
import {Errors, Form} from './../../../components/validations/forms.js'
const namespaced = true;

const state = {
    defaultSearchFilter: {
        companies: [],
        companies2: [],
        sponsorCompanies: [],
        sponsorCompanies2: [],
        branches: [],
        branches2: [],
        departments: [],
        departments2: [],
        cities: [],
        cities2: [],
        nationalities: [],
        nationalities2: [],
        designations: [],
        designations2: [],
        religions: [],
        religions2: [],
        shiftPlans: [],
        shiftPlans2: [],
        employees: [],
        employees2: [],
        dateFrom: null,
        dateFrom2: null,
        dateTo: null,
        dateTo2: null,
        noShiftPlans: 0,
        status: [],
        status2: [],
        isActive: false,
        resultsView: 'employees',
    },
    searchFilter: {
        companies: [],
        companies2: [],
        sponsorCompanies: [],
        sponsorCompanies2: [],
        branches: [],
        branches2: [],
        departments: [],
        departments2: [],
        cities: [],
        cities2: [],
        nationalities: [],
        nationalities2: [],
        designations: [],
        designations2: [],
        religions: [],
        religions2: [],
        shiftPlans: [],
        shiftPlans2: [],
        employees: [],
        employees2: [],
        dateFrom: null,
        dateFrom2: null,
        dateTo: null,
        dateTo2: null,
        noShiftPlans: 0,
        status: [],
        status2: [],
        isActive: false,
        resultsView: 'employees',
    },

    sorting: {
        page: 1,
        sortBy: 'id',
        sortOrder: 'asc',
        limit: 13,
    },

    timesheetUsers: [],
    timesheetPages: [],
    missingPunchUsers: [],
    absentUsers: [],
    selectedUser: {},

    shiftPlans: [],
    shiftDayPolicies: [],

};

const getters = {
    getDefaultSearchFilters (state) {
        return state.defaultSearchFilter
    },

    getSearchFilters (state) {
        return state.searchFilter
    },

    getSorting (state) {
        return state.sorting
    },

    getTimesheetPages (state) {
        return state.timesheetPages
    },

    getTimesheetUsers (state) {
        return state.timesheetUsers
    },

    getMissingPunchUsers (state) {
        return state.missingPunchUsers
    },

    getAbsentUsers (state) {
        return state.absentUsers
    },

    getSelectedUser (state) {
        return state.selectedUser
    },

    getShiftPlans (state) {
        return state.shiftPlans
    },

    getShiftDayPolicies (state) {
        return state.shiftDayPolicies
    },


};


const mutations = {
    resetSearchFilters (state, payload){
        state.searchFilter = JSON.parse(JSON.stringify(state.defaultSearchFilter));
        console.log('Search Filter Reset')
    },

    setTimesheetPages (state, payload) {
        state.timesheetPages = payload
    },

    setTimesheetUsers (state, payload) {
        state.timesheetUsers = payload
    },

    setMissingPunchUsers (state, payload) {
        state.missingPunchUsers = payload
    },

    setAbsentUsers (state, payload) {
        state.absentUsers = payload
    },

    setSelectedUser (state, payload) {
        state.selectedUser = payload
    },

    setShiftPlans (state, payload) {
        state.shiftPlans = payload
    },

    setShiftDayPolicies (state, payload) {
        state.shiftDayPolicies = payload
    },


};


const actions = {
    fetchTimesheetUsers ({commit, dispatch}, payload) {
        return new Promise((resolve, reject) => {
            let params = new URLSearchParams();
            axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
            axios.get('/api/attendance/user', {
                params: {
                    companies: payload.filters.companies,
                    sponsorCompanies: payload.filters.sponsorCompanies,
                    branches: payload.filters.branches,
                    departments: payload.filters.departments,
                    cities: payload.filters.cities,
                    nationalities: payload.filters.nationalities,
                    designations: payload.filters.designations,
                    religions: payload.filters.religions,
                    shiftPlans: payload.filters.shiftPlans,
                    dateFrom: payload.filters.dateFrom,
                    dateTo: payload.filters.dateTo,
                    employees: payload.filters.employees,
                    status: payload.filters.status,
                    noShiftPlans: payload.filters.noShiftPlans,
                    resultsView: payload.filters.resultsView,
                    limit: payload.sorting.limit,
                    page: payload.sorting.page,
                    sortBy: payload.sorting.sortBy,
                    sortOrder: payload.sorting.sortOrder,
                }
            })
                .then(res => {
                    commit('setTimesheetUsers', res.data.data)
                    commit('setTimesheetPages', {meta: res.data.meta, links:res.data.links})

                    console.log('fetchTimesheetUsers - fetchTimesheetUsers Fetched.');
                    resolve(res.data.data);
                })
                .catch(error => {
                    const issues = new Errors();
                    issues.record(error.response);
                    reject(issues);
                })
        })
    },

    fetchTimesheetUser ({commit, dispatch}, payload) {
        return new Promise((resolve, reject) => {
            let params = new URLSearchParams();
            axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
            axios.get('/api/attendance/user', {
                params: {
                    dateFrom: payload.dateFrom,
                    dateTo: payload.dateTo,
                    resultsView: 'employee',
                    employees: payload.employees,
                }
            })
                .then(res => {
                    console.log('fetchTimesheetUser - fetchTimesheetUser Fetched.');
                    resolve(res.data.data);
                })
                .catch(error => {
                    const issues = new Errors();
                    issues.record(error.response);
                    reject(issues);
                })
        })
    },

    fetchTimesheetSingleUser ({commit, dispatch}, payload) {
        return new Promise((resolve, reject) => {
            let params = new URLSearchParams();
            axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
            axios.get('/api/attendance/user', {
                params: {
                    dateFrom: payload.filters.dateFrom,
                    dateTo: payload.filters.dateTo,
                    employees: [payload.userID],
                    resultsView: 'employee',
                }
            })
                .then(res => {
                    console.log('Single Timesheet User Fetched.');
                    resolve(res.data.data);
                })
                .catch(error => {
                    const issues = new Errors();
                    issues.record(error.response);
                    reject(issues);
                })
        })
    },

    fetchShiftPlans ({commit, dispatch}, payload) {
        return new Promise((resolve, reject) => {
            let params = new URLSearchParams();
            axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
            axios.get('/api/attendance/shift_plan', {
                params: {
                }
            })
                .then(res => {
                    commit('setShiftPlans', res.data.data)
                    console.log('fetchShiftPlans - fetchShiftPlans Fetched.');
                    resolve(res.data.data);
                })
                .catch(error => {
                    const issues = new Errors();
                    issues.record(error.response);
                    reject(issues);
                })
        })
    },

    fetchShiftDayPolicies ({commit, dispatch}, payload) {
        return new Promise((resolve, reject) => {
            let params = new URLSearchParams();
            axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
            axios.get('/api/attendance/shift_day_policy', {
                params: {
                }
            })
                .then(res => {
                    commit('setShiftDayPolicies', res.data.data)
                    console.log('setShiftDayPolicies - setShiftDayPolicies Fetched.');
                    resolve(res.data.data);
                })
                .catch(error => {
                    const issues = new Errors();
                    issues.record(error.response);
                    reject(issues);
                })
        })
    },


    updateMissingOvertime ({commit, dispatch}, payload) {
        return new Promise((resolve, reject) => {
            axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
            axios.put('/api/attendance/attendance/'+payload.attendance_id, {
                adjustedMissingCurrent: payload.adjustedMissing,
                adjustedOvertimeCurrent: payload.adjustedOvertime,
            })
                .then(res => {
                    console.log('updateMissingOvertime - Missing and Overtime Updated.');
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        })
    },


    updatePunchesOrder ({commit, dispatch}, payload) {
        return new Promise((resolve, reject) => {
            axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
            axios.post('/api/attendance/attendance/updatePunches', {
                attendanceID: payload.attendanceID,
                checkIn: payload.checkIn,
                checkOut: payload.checkOut,
                breakStart: payload.breakStart,
                breakEnd: payload.breakEnd,
                checkIn2: payload.checkIn2,
                checkOut2: payload.checkOut2,
                checkIn3: payload.checkIn3,
                checkOut3: payload.checkOut3,
                checkIn4: payload.checkIn4,
                checkOut4: payload.checkOut4,
            })
                .then(res => {
                    console.log('updatePunchesOrder - Punches Order Updated.');
                    resolve(res.data);

                })
                .catch(error => {
                    reject(error.response);
                })
        })
    },

    addMissingPunch ({commit, dispatch}, payload) {
        return new Promise((resolve, reject) => {
            axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
            axios.post('/api/attendance/punch', {
                attendanceID: payload.attendanceID,
                punchDate: payload.punchDate,
                userID: payload.userID,
            })
                .then(res => {
                    console.log('addMissingPunch - Punches Added.');
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        })
    },


    addLeave ({commit, dispatch}, payload) {
        return new Promise((resolve, reject) => {
            axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
            axios.post('/api/attendance/leave', {
                dateFrom: payload.dateFrom,
                dateTo: payload.dateTo,
                userID: payload.userID,
                description: payload.description,
                leaveType: payload.leaveType,
            })
                .then(res => {
                    console.log('addLeave - Leave Added.');
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        })
    },


    fetchTimesheets ({commit, dispatch}, payload) {
        return new Promise((resolve, reject) => {
            let params = new URLSearchParams();
            axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
            axios.get('/api/attendance/attendance', {
                params: {
                    users_id: payload.users_id,
                    dateFrom: payload.dateFrom,
                    dateTo: payload.dateTo,
                }
            })
                .then(res => {
                    console.log('fetchTimesheets - Attendances Fetched.');
                    resolve(res.data.data);
                })
                .catch(error => {
                    const issues = new Errors();
                    issues.record(error.response);
                    reject(issues);
                })
        })
    },

    resetSearchFilters ({commit, dispatch}) {
        commit('resetSearchFilters')
    },


    updateEmployee ({commit, dispatch}, payload) {
        return new Promise((resolve, reject) => {
            axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
            axios.put('/api/company/user/'+payload.id, {
                companies_id: payload.companies_id,
                sponsor_companies_id: payload.sponsor_companies_id,
                name: payload.name,
                name_lang: payload.name_lang,
                nationalID: payload.nationalID,
                designations_id: payload.designations_id,
                nationalities_id: payload.nationalities_id,
                religions_id: payload.religions_id,
                city: payload.city,
                supervisor: payload.supervisor,
                email: payload.email,
                password: payload.password,
                status: payload.status,
                branches: payload.branches,
                designations: payload.designations,
                departments: payload.departments,
            })
                .then(res => {
                    console.log('Employee Updated');
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        })
    },


    storeEmployee ({commit, dispatch}, payload) {
        return new Promise((resolve, reject) => {
            axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
            axios.post('/api/company/user', {
                id: payload.id,
                companies_id: payload.companies_id,
                sponsor_companies_id: payload.sponsor_companies_id,
                name: payload.name,
                name_lang: payload.name_lang,
                nationalID: payload.nationalID,
                designations_id: payload.designations_id,
                nationalities_id: payload.nationalities_id,
                religions_id: payload.religions_id,
                city: payload.city,
                supervisor: payload.supervisor,
                email: payload.email,
                password: payload.password,
                status: payload.status,
                branches: payload.branches,
                designations: payload.designations,
                departments: payload.departments,
            })
                .then(res => {
                    console.log('Employee Stored');
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        })
    },

    deleteUser ({commit, dispatch}, payload) {
        return new Promise((resolve, reject) => {
            axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
            axios.delete('/api/attendance/user/'+payload)
                .then(res => {
                    console.log('deleteUser - deleteUser Updated.');
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        })
    },

};

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/attendance/employees.js